import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { setMockHomeworkSession } from '@/utils/homeworkSession';
import { exchangePracticeLaunchTicket } from '@/api/practiceLaunch';

function clearLaunchTicketFromAddress() {
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#/launch`);
}

function validRecordId(value: number | string | undefined) {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : undefined;
}

export default function PracticeLaunch() {
  const { ticket: pathTicket } = useParams();
  const location = useLocation();
  const ticket = pathTicket || new URLSearchParams(location.search).get('ticket') || undefined;
  const navigate = useNavigate();
  const transport = location.pathname === '/teacher-launch' ? 'teacher' : 'student';
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    if (!ticket) {
      setError('作业启动凭证无效，请返回作业重新开始。');
      return;
    }
    void exchangePracticeLaunchTicket(ticket, transport).then(response => {
      clearLaunchTicketFromAddress();
      const preview = response.mode === 'assignment_preview';
      const teacher = response.mode === 'assignment_preview' || response.mode === 'teacher_sandbox';
      const recordId = teacher ? 9000000000000000 : validRecordId(response.scope?.native_record_id || response.record_id);
      const isAssignedMock = ((transport === 'teacher' && teacher) || (transport === 'student' && response.mode === 'assignment_student'))
        && response.exercise?.kind === 'mock'
        && recordId;
      if (!active) return;
      if (!isAssignedMock) {
        setError('当前入口不是学生正式模考作答入口，已阻止打开模考页面。');
        return;
      }
      if (!response.session_token || !response.expires_at || !recordId) {
        setError('作业会话无效，请返回作业重新开始。'); return;
      }
      setMockHomeworkSession({ token: response.session_token, expiresAt: response.expires_at, recordId, transport, mode: response.mode, allowWrite: response.scope?.allow_write === true });
      navigate(preview ? `/mocklistening/${recordId}` : `/mockstart/${recordId}`, { replace: true });
    }).catch(() => {
      clearLaunchTicketFromAddress();
      if (active) setError('无法打开模考，请返回作业重新开始。');
    });
    return () => { active = false; };
  }, [navigate, ticket, transport]);

  if (error) return <main role="alert">{error}</main>;
  return <main role="status" aria-live="polite">正在安全打开模考...</main>;
}
